import Dom2 from './dom2.vue'
export default Dom2


// WEBPACK FOOTER //
// ./src/pages/Dom2/index.js